define('specific/mosaic/views/MosaicView', [
    'specific/mosaic/templates/mosaic',
    'components/factory/Factory',
    'specific/mosaic/models/RowModel',
    'specific/mosaic/views/RowView'
], function(tpl, Factory, RowModel, RowView) {

    var MosaicView = Mazarine.View.extend({

        events: {
            'click .js-maz-item': 'onClickItem',
            'click .maz-view-more-wrapper .maz-view-more': 'onClickViewMore',
            'click .maz-view-more-wrapper-video .maz-view-more': 'onClickViewMoreVideo',
            "click .js-maz-video-iphone": 'onClickVideoIphone',
        },

        template: tpl,

        className: "maz-mosaic-view",

        videosIphone: [],

        initialize: function(){
            this.listenTo(this.model, 'change:datas', this.onDatasChange);
        },

        afterRender: function() {
            if (this.model.get('bestOf')) {
                this.model.set('isReady', true);
            } else {
                this.preloadImages();

                if (this.model.get('isIphone')) {
                    var pictures = this.model.get('pictures');
                    _.each(pictures, function(item, index){
                        var model = Factory.createModelFromData( item.videoInfos );

                        this.videosIphone[index] = Factory.createViewFromModel( model );

                        this.$(".js-maz-video-iphone[data-id='" + index + "']").append( this.videosIphone[index].render().$el );

                        if( this.videosIphone[index].afterRender ) {
                            this.videosIphone[index].afterRender();
                        }
                    }, this);
                }
            }
            this.hideItemVideo();
            this.copyTitle();
        },

        hideItemVideo: function( e ) {
            $('.maz-section-pictures .maz-item').each(function(index, item) {
              if (index > 8) $(item).addClass('maz-item-hidden');
            });

        },

        copyTitle: function( e ) {
            var title = $('#maz-source-title-mosaic').html();
            $('#maz-container-title-mosaic').html(title);
        },

        onClickVideoIphone: function( e ) {
            e.preventDefault();

            this.videosIphone[$(e.currentTarget).data('id')].play();
        },

        preloadImages: function() {
            var pictures= this.model.get('pictures'),
                assetsUrl = this.model.get('assets_url'),
                preloadImages = [];

            _.each(pictures, function(picture){
                preloadImages.push(assetsUrl + picture['img-url']);
            });

            this.loadImages(preloadImages);
        },

        progress: function(img, nbImagesPreloaded, nbImagesToPreload, finished) {
            if (finished) {
                this.model.set('isReady', true);
            }
        },

        onDatasChange: function( model, datas ) {
            this.$el.find('.maz-rows-wrapper').empty();

            if( datas.length === 0 ) {
                this.$('.maz-no-results').addClass('maz-show');
            } else {
                this.$('.maz-no-results').removeClass('maz-show');

                var tmp = new Immutable.List( datas ),
                    chunks = [],
                    nbChunks = Math.ceil( tmp.size / this.model.get('nbImagesToAdd') );

                for( var i = 0; i < nbChunks; i++ ) {
                    chunks.push( tmp.slice( i * this.model.get('nbImagesToAdd'), Math.min( tmp.size, ( i + 1 ) * this.model.get('nbImagesToAdd') ) ).toArray() );
                }

                _.each( chunks, function( row ) {
                    var model = new RowModel( { rowDatas: row, viewId: _.uniqueId( 'row-view-' ) } );
                    var view = new RowView( { model: model } );

                    this.$el.find('.maz-rows-wrapper').append( view.render().$el );
                    view.afterRender();
                }, this );
            }
        },

        onClickItem: function( e ) {

            var id = $( e.currentTarget ).attr('data-id'),
                requestOpenPopin = this.model.get('requestOpenPopin');


            requestOpenPopin( id, true, this.model.get('bestOf') );

        },

        onClickViewMore: function() {
            this.$('.maz-view-more-wrapper').addClass('maz-is-loading');
            this.model.set('nbImagesRequested', this.model.get('nbImagesToAdd'));
        },

        onClickViewMoreVideo: function() {
          this.$('.maz-view-more-wrapper-video').addClass('maz-view-more-wrapper-video-hidden');
          $('.maz-section-pictures .maz-item').removeClass('maz-item-hidden');
        },

        waitForRequest: function() {
            this.$el.addClass('maz-is-loading');
        },

        getItemDatasById: function( id ) {
            return _.findWhere( this.model.get('datas'), { id: id} );
        },

        getPreviousId: function( id ) {
            var index = _.indexOf( _.pluck( this.model.get('datas'), 'id' ), id );
            return index > 0 ?  this.model.get('datas')[ index - 1].id : null;
        },

        getNextId: function( id ) {
            var index = _.indexOf( _.pluck( this.model.get('datas'), 'id' ), id );
            return index < this.model.get('datas').length - 1 ? this.model.get('datas')[ index + 1].id : null;
        },

        onRequestSuccess: function( datas, cleanDatas, hasMoreItems ) {
            this.$el.removeClass('maz-is-loading');
            this.$('.maz-view-more-wrapper').removeClass('maz-is-loading');

            this.model.set('nbImagesRequested', 0);
            var newDatas = new Immutable.List( datas );

            if( !cleanDatas ) {
                var tmp = new Immutable.List( this.model.get('datas') );
                newDatas = tmp.concat( datas );
            }

            this.model.set('datas', newDatas.toArray());

            if( hasMoreItems ) {
                this.$('.maz-view-more-wrapper').removeClass('maz-no-more-items');
            } else {
                this.$('.maz-view-more-wrapper').addClass('maz-no-more-items');
            }
        }
    });

    return MosaicView;
});
